import { createContext, useContext, useState } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewsActionsModalContext = /*#__PURE__*/createContext({
  deleteSingleViewModalProps: undefined,
  setDeleteSingleViewModalProps: emptyFunction,
  cloneSingleViewModalProps: undefined,
  setCloneSingleViewModalProps: emptyFunction,
  exportSingleViewModalProps: undefined,
  setExportSingleViewModalProps: emptyFunction,
  manageSharingSingleViewModalProps: undefined,
  setManageSharingSingleViewModalProps: emptyFunction,
  renameViewModalProps: undefined,
  setRenameViewModalProps: emptyFunction,
  addDescriptionModalProps: undefined,
  setAddDescriptionModalProps: emptyFunction
});
export const useViewsActionsModalContext = () => {
  return useContext(ViewsActionsModalContext);
};
export const ViewsActionsProvider = ({
  children
}) => {
  // delete
  const [deleteSingleViewModalProps, setDeleteSingleViewModalProps] = useState(undefined);

  // clone
  const [cloneSingleViewModalProps, setCloneSingleViewModalProps] = useState(undefined);

  // export
  const [exportSingleViewModalProps, setExportSingleViewModalProps] = useState(undefined);

  // manage sharing
  const [manageSharingSingleViewModalProps, setManageSharingSingleViewModalProps] = useState(undefined);

  // rename view modal
  const [renameViewModalProps, setRenameViewModalProps] = useState(undefined);

  // add description modal
  const [addDescriptionModalProps, setAddDescriptionModalProps] = useState(undefined);
  const value = {
    deleteSingleViewModalProps,
    setDeleteSingleViewModalProps,
    cloneSingleViewModalProps,
    setCloneSingleViewModalProps,
    exportSingleViewModalProps,
    setExportSingleViewModalProps,
    manageSharingSingleViewModalProps,
    setManageSharingSingleViewModalProps,
    renameViewModalProps,
    setRenameViewModalProps,
    addDescriptionModalProps,
    setAddDescriptionModalProps
  };
  return /*#__PURE__*/_jsx(ViewsActionsModalContext.Provider, {
    value: value,
    children: children
  });
};